<template>
  <h1 class="MediaGridItemTitle"
    v-if="data.title"
    v-html="data.title"
    :class="titleClasses">
  </h1>
</template>

<script>
export default {
  name: 'MediaGridItemTitle',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    /**
     * Decmial version of the span fraction
     * @return {Number}
     */
    spanDecimal () {
      if (!this.data.span) return 0.25

      const fractionStr = this.data.span

      if (!fractionStr.split) return 0.25

      const split = fractionStr.split('/')

      return split[0] / split[1]
    },

    /**
     * Classes for the title
     * @return {Object}
     */
    titleClasses () {
      return {
        'MediaGridItemTitle--isSmall': this.spanDecimal <= 0.34,
        'MediaGridItemTitle--isLarge': this.spanDecimal > 0.34
      }
    }
  }
}
</script>

<style>
.MediaGridItemTitle {
  font-family: var(--font-family-sans);
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
}

.MediaGridItemTitle--isLarge {
  margin-top: 14px; /* 18px after leading compensation */
  margin-bottom: -2px; /* 0px after leading compensation */

  @media (min-width: 400px) {
    font-family: var(--font-family-sans);
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
  }
}

.MediaGridItemTitle--isSmall {
  margin-top: 8px; /* 12px after leading compensation */
  margin-bottom: -4px; /* 0px after leading compensation */
}
</style>



// WEBPACK FOOTER //
// MediaGridItemTitle.vue?0f510c30